import functions from '../functions.js';
import { details } from './details';
import { DetailsCart } from './details-cart.js';
import { DeparturePicker } from '../components/departure-picker.js';

$(() => {
    detailsPackageWithFlightApi.init();
});

const detailsPackageWithFlightApi = {
    $details: null,
    $booking: null,
    $form: null,
    form: null,
    $cart: null,
    cart: [],
    calc: {},
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        aDateFrom: null,
        aDateTo: null,
        objectGroupId: null,
        calcErrorMessages: null,
        dynamicPackage: null,
        time: null,
    },
    defaults: {
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: 1,
    },
    init() {
        this.$details = $('.page-type-details');
        this.$booking = $('#booking');
        this.params.objectGroupId = this.$booking.attr('data-objectgroupid');
        this.params.dynamicPackage = +this.$booking.attr('data-dynamicpackage');

        if( ! (this.$details[0] && this.params.objectGroupId === "1" && [1,2].includes(this.params.dynamicPackage) && this.$booking.attr('data-flightapi') == 1)) {
            return;
        }

        this.$form = $('.availability-form');
        this.form = this.$form[0];

        this.params.objectId = this.$booking.attr('data-objectid');
        this.params.referenceId = this.$booking.attr('data-referenceid');
        this.params.calcErrorMessages = this.$booking.attr('data-calcErrorMessages') ? JSON.parse(this.$booking.attr('data-calcErrorMessages')) : null;
        this.allowedServices = $('[data-allowedservices]').attr('data-allowedservices');
        this.allowedServices = this.allowedServices ? JSON.parse(this.allowedServices) : [];
        this.params.isTravelgate = $('[data-isTravelgate]').attr('data-istravelgate');

        this.getParams();
        if(! this.params.dates && this.params.dateFrom && this.params.dateTo) {
            this.params.dates = this.params.dateFrom + ' - ' + this.params.dateTo;
        }

        //this.getCalculation();
        
        this.$form.on('submit', e => {
            e.preventDefault();
            let params = functions.getFormData($(e.currentTarget));
            //this.params.unitId = null;
            functions.setUrlData(params, true, true);
        });

        // check availability on form change (not only on btn click)
        /*$('[name="dates"], [name="guests"]').on('change', () => {
            const data = functions.getFormData(this.$form);
            if (data.dates && data.guests) {
                this.$form.trigger('submit');
            }
        });*/

        this.prepareAvailabilityForm();

        this.$cart = $('.details-cart');
        this.cart = this.$cart.length ? new DetailsCart(this.params) : [];

        $(window).on('hashchange', e => {
            this.getParams();
            //this.params.guests = this.params.adultsOnly ? this.params.guests.split(',')[0] + ',0' : this.params.guests;
            this.showTransportTicket();

            this.getCalculation(this.params);
        });

        if(this.$cart.length) {
            const $btnBooking = $('.btn-booking');

            $btnBooking.on('click', e => {
                e.preventDefault();
                let cartData = [];

                detailsPackageWithFlightApi.cart.cartItems.forEach(item => {
                    item = JSON.parse(item);
                    cartData.push({
                        'unitId': item.unitId,
                        'dateFrom': item.dateFrom,
                        'dateTo': item.dateTo,
                        'aDateFrom': item.aDateFrom,
                        'aDateTo': item.aDateTo,
                        'guests': item.guests,
                        'flightUnitId': item.transportUnitId,
                        'placeFromId': item.placeFromId,
                        'time': item.time,
                        'serviceCode': item.serviceCode,
                        'serviceId': item.serviceId,
                        'flightRefId': item.flightRefId,
                        'pricelistId': detailsPackageWithFlightApi.params.pricelistId,
                        'dynamicPackage': detailsPackageWithFlightApi.params.dynamicPackage
                    });
                });

                if(detailsPackageWithFlightApi.cart.cartItems.length) {
                    location = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=' + detailsPackageWithFlightApi.params.dynamicPackage;
                } else {
                    $('#detailsCartModal').modal('show');
                    setTimeout(() => {
                        $('#detailsCartModal').modal('hide');
                    }, 2500);
                }
            });
        }
        else {
            $(document).on('click', '.unit .btn-book-one-unit', e => {

                e.preventDefault();
                const $btnBooking = $(e.currentTarget);

                if (! detailsPackageWithFlightApi.params.dateFrom || ! detailsPackageWithFlightApi.params.dateTo || ! detailsPackageWithFlightApi.params.guests) {
                    window.setAlertBooking($btnBooking);
                    return;
                }

                const unitId = $btnBooking.attr('data-unitid');

                let cartData = {
                    'unitId': unitId,
                    'dateFrom': detailsPackageWithFlightApi.params.dateFrom,
                    'dateTo': detailsPackageWithFlightApi.params.dateTo,
                    'aDateFrom': detailsPackageWithFlightApi.params.aDateFrom,
                    'aDateTo': detailsPackageWithFlightApi.params.aDateTo,
                    'time': detailsPackageWithFlightApi.params.time,
                    'guests': detailsPackageWithFlightApi.params.guests,
                    'flightUnitId': detailsPackageWithFlightApi.params.transportUnitId,
                    'placeFromId': detailsPackageWithFlightApi.params.placeFromId,
                    'pricelistId': $btnBooking.attr('data-pricelistid'),
                    'serviceCode': $btnBooking.attr('data-servicecode') ? encodeURIComponent($btnBooking.attr('data-servicecode')) : null,
                    'serviceId': $btnBooking.attr('data-serviceid'),
                    'dynamicPackage': detailsPackageWithFlightApi.params.dynamicPackage,
                    'flightRefId': $('[name="flightRefId"]:checked').val()
                };

                let extras = $btnBooking.attr('data-extra');
                if (extras) {
                    extras = JSON.parse(extras);

                    Object.keys(extras).forEach(function(key) {
                        let val = extras[key];
                        if (key === 'optionRefId' || key === 'remoteUnitId') {
                            val = encodeURIComponent(val);
                        } else if (key === 'cancellationPolicy') {
                            return;
                        }
                        cartData[key] = val;
                    });
                }

                location = $(e.currentTarget).attr('data-href') + '?dynamicPackage='+detailsPackageWithFlightApi.params.dynamicPackage+'&cart_data=' + JSON.stringify([cartData]);
            });

        }

        $(document).on('change', '.block-totals-per-service [type="radio"]', e => {

            const $unit = $(e.currentTarget).closest('.unit');
            const $addToCart = $unit.find('.add-to-cart');
            const $btnBooking = $unit.find('.btn-book-one-unit');
            const $radioService = $unit.find('[type="radio"]:checked');
            const $totalPerService = $radioService.closest('.total-per-service');

            let total = $totalPerService.find('[data-totalperservice]').attr('data-totalperservice');
            let totalOld = $totalPerService.find('[data-oldtotalperservice]').attr('data-oldtotalperservice');
            let currency = $totalPerService.find('[data-currency]').attr('data-currency');
            let bookingStatus = $totalPerService.find('[data-bookingstatus]').attr('data-bookingstatus');
            let pricelistid = $totalPerService.find('[data-pricelistid]').attr('data-pricelistid');
            let serviceId = $radioService.val();
            let serviceKey = $radioService.attr('data-servicekey');
            let extras = $radioService.attr('data-extra');

            if ($addToCart.length) {
                $addToCart.attr('data-' + serviceKey, serviceId);
                $addToCart.attr('data-unitcarttotal', total);
                $addToCart.attr('data-unitcarttotalold', totalOld);
                $addToCart.attr('data-currencysymbol', currency);

                $addToCart.attr('data-datefrom', detailsPackageWithFlightApi.params.dateFrom);
                $addToCart.attr('data-dateto', detailsPackageWithFlightApi.params.dateTo);
                $addToCart.attr('data-guests', detailsPackageWithFlightApi.params.guests);

                $addToCart.attr('data-adatefrom', detailsPackageWithFlightApi.params.aDateFrom);
                $addToCart.attr('data-adateto',detailsPackageWithFlightApi. params.aDateTo);

                $addToCart.attr('data-transportunitid', detailsPackageWithFlightApi.params.transportUnitId);
                $addToCart.attr('data-placefromid', detailsPackageWithFlightApi.params.placeFromId);
                $addToCart.attr('data-time', detailsPackageWithFlightApi.params.time);
                $addToCart.attr('data-flightrefid', $('[name="flightRefId"]:checked').val());

            } else {
                $btnBooking.attr('data-' + serviceKey, serviceId);
                $btnBooking.attr('data-pricelistid', pricelistid);
                $btnBooking.attr('data-extra', extras);

                if (this.params.isTravelgate) {
                    const unitId = $unit.attr('data-unitid');
                    extras = JSON.parse(extras);

                    if (extras.cancellationPolicy[0]) {
                        let $cp = '<div>';
                        $cp += 'Možete besplatno otkazati rezervaciju do <strong>' + functions.decreaseDate(extras.cancellationPolicy[0].deadline, 1) + '</strong><br>';

                        extras.cancellationPolicy.forEach((item, key) => {
                            if (item.penaltyType === 'IMPORT') {
                                $cp += 'Za otkazivanja od <strong>' + functions.formatDate(item.deadline) + '</strong> naknada iznosi <strong> ' + functions.formatMoney(item.value, 2, ',', '') +' '+ item.currency + '</strong>.<br>';
                            }
                            else if (item.penaltyType === 'PERCENT') {
                                $cp += 'Za otkazivanja od <strong>' + functions.formatDate(item.deadline) + '</strong> naknada iznosi <strong> ' + item.value + '%</strong>.<br>';
                            }
                            else if (item.penaltyType === 'NIGHTS') {
                                $cp += 'Za otkazivanja od <strong>' + functions.formatDate(item.deadline) + '</strong> naplaćuje se naknada u iznosu  <strong> ' + item.value + 'noćenja</strong>.<br>';
                            }
                        });
                        $cp += '</div>';

                        const board = $(e.currentTarget).closest('.form-check').find('.form-check-label').text() ? $(e.currentTarget).closest('.form-check').find('.form-check-label').text() : $unit.find(".service-label").text();
                        const $unitModal =  $("#unitModal-" + unitId);

                        $unitModal.find("#cancellationPolicy-" + unitId).html($cp);
                        $unitModal.find('.modal-service-name').html(board);
                    }
                }

                $btnBooking.text(bookingStatus === 'Request' ? $btnBooking.attr('data-requestLabel') : $btnBooking.attr('data-bookingLabel'));
            }
        });

        detailsPackageWithFlightApi.prepareFlightEvents();
    },
    isFlightComboAvailable(flightRefId, guests) {
        let isAvailable = false;
        guests = +guests.split(',')[0] + +guests.split(',')[1];
        detailsPackageWithFlightApi.calc.flights.departures.forEach(departure => {
            departure.offers.forEach(offer => {
                offer.returns.forEach(return_item => {
                    if (return_item.flightRefId === flightRefId) {

                        let $departure = $('[value="'+offer.id+'"]');
                        let dAvailable = +$departure.attr('data-quantity');

                        let $return = $('[value="'+flightRefId+'"]');
                        let rAvailable = +$return.attr('data-quantity');
                        isAvailable = !!(dAvailable >= guests && rAvailable >= guests);
                    }
                });
            });
        });

        return isAvailable;
    },
    prepareFlightEvents() {

        window.isFlightComboAvailable = (flightRefId, guests) => {
            return detailsPackageWithFlightApi.isFlightComboAvailable(flightRefId, guests);
        }

        window.prepareFlightAvailability = (flightRefId, guests, type) => {
            let totalGuests = +guests.split(',')[0] + +guests.split(',')[1];

            detailsPackageWithFlightApi.calc.flights.departures.forEach(departure => {
                departure.offers.forEach(offer => {
                    offer.returns.forEach(return_item => {
                        if (return_item.flightRefId === flightRefId) {

                            let $departure = $('[value="'+offer.id+'"]');
                            let dAvailable = type === 'add' ? +$departure.attr('data-quantity') - totalGuests : +$departure.attr('data-quantity') + totalGuests;
                            $departure.attr('data-quantity', dAvailable);

                            //$departure.attr('disabled', dAvailable === 0);

                            $('[for="'+offer.id+'"]').find('.availableSeatCount').html(dAvailable);
                            $('[for="'+offer.id+'"]').toggleClass('text-decoration-line-through', dAvailable === 0 || totalGuests > dAvailable);

                            let $return = $('[value="'+flightRefId+'"]');
                            let rAvailable = type === 'add' ? +$return.attr('data-quantity') - totalGuests : +$return.attr('data-quantity') + totalGuests;
                            $return.attr('data-quantity', rAvailable);

                            //$return.attr('disabled', rAvailable === 0);

                            $('[for="'+flightRefId+'"]').find('.availableSeatCount').html(rAvailable);
                            $('[for="'+flightRefId+'"]').toggleClass('text-decoration-line-through', rAvailable === 0 || totalGuests > rAvailable);
                        }
                    });
                });
            });
        }

        $(document).on('change', '[name^="flightDepartureId"]', e => {
            //const $flightDeparture = $('[name^="flightDepartureId"]:checked');
            const $flightDeparture = $(e.currentTarget);
            const flightDepartureId = $flightDeparture.val();

            $('[name="flightDepartureId"]').attr('checked', false);
            $('#flight-departure-accordion .accordion-item').removeClass('show');
            $('[name="flightDepartureId"][value="' + flightDepartureId + '"]').parents('.accordion-item').addClass('show');
            $('[name="flightDepartureId"][value="' + $('[name="flightDepartureId-1"]:checked').val() + '"]').attr('checked', true);

            //$('#flight-departure-accordion, #flight-departure-accordion-modal').find('.accordion-collapse').collapse('hide');

            /*$flightDeparture.each((index, departure) => {
                const $departure = $(departure);
                if ( ! $departure.hasClass('alternative-offer')) {
                    const target = $departure.closest('.accordion-item').find('.accordion-collapse');
    
                    if ( ! target.hasClass('show')) {
                        $('#flight-departure-accordion, #flight-departure-accordion-modal').find('.accordion-collapse').collapse('hide');
                        $(target).collapse('show');
                    }
                }
            });*/

            /*if ( ! $flightDeparture.hasClass('alternative-offer')) {
                const target = $flightDeparture.closest('.accordion-item').find('.accordion-collapse');

                if ( ! target.hasClass('show')) {
                    $('#flight-departure-accordion, #flight-departure-accordion-modal').find('.accordion-collapse').collapse('hide');
                    $(target).collapse('show');
                }

            }*/

            $(".return-title").remove();
            $(".flight-return .accordion").empty();
            $('.unit[data-dynamicunitid]').remove();
            $(".units .unit").addClass('d-none');

            //$('.flight-return-count').text(detailsPackageWithFlightApi.calc.flights.departures.length);

            setTimeout(() => {
                detailsPackageWithFlightApi.calc.flights.departures.forEach(departure => {
                    departure.offers.forEach(offer => {
                        if (offer.id === flightDepartureId) {
    
                            $('.flight-return-count').text(offer.returns.length);
                            offer.returns.length > 1 ? $('.btn-flight-return-count').removeClass('d-none') : $('.btn-flight-return-count').addClass('d-none');
    
                            $(".flight-return .accordion").empty();

                            offer.returns.forEach(return_item => {
                                $(".flight-return .accordion:not(.accordion-modal").append(detailsPackageWithFlightApi.prepareFlightOptionHtml(return_item, 'flightRefId', return_item.flightRefId, +offer.total + +return_item.total, [], 0));
                                $(".flight-return .accordion.accordion-modal").append(detailsPackageWithFlightApi.prepareFlightOptionHtml(return_item, 'flightRefId', return_item.flightRefId, +offer.total + +return_item.total, [], 1));
                            });
                        }
                    });
                });

                ! $("[name='flightRefId']").closest('.accordion-item.show').length && $("[name^='flightRefId']:first, #flightSelect [name^='flightRefId']:first").each((index, element) => {
                    $(element).attr('checked', true).trigger('change');
                });
            });
            

        });

        $(document).on('change', '[name^="flightRefId"]', e => {
            const $flightRef = $('[name^="flightRefId"]:checked');
            const flightRefId = $flightRef.val();
            const flightDepartureId = $('[name="flightDepartureId"]:checked').val();
            //const $accordionItem = $flightRef.closest('.accordion-item');
            const $accordionItem = $('[name="flightRefId"][value="' + $('[name="flightRefId-1"]:checked').val() + '"]').parents('.accordion-item').first();
            $('#flight-return-accordion .accordion-item, #flight-return-accordion-modal .accordion-item').removeClass('show');

            $('.unit[data-dynamicunitid]').remove();
            $(".units .unit").addClass('d-none');

            //$('#flight-return-accordion, #flight-return-accordion-modal').find('.accordion-collapse').collapse('hide');

            $accordionItem.addClass('show');
            $('[name="flightRefId"][value="' + $('[name="flightRefId-1"]:checked').val() + '"]').attr('checked', true);

            //$('#flight-return-accordion, #flight-return-accordion-modal').find('.accordion-collapse').collapse('hide');
            //const target = $flightRef.closest('.accordion-item').find('.accordion-collapse').first();
            //$(target).collapse('show');

            //detailsPackageWithFlightApi.prepareCalcPerFlightCombo(flightDepartureId, flightRefId);
            detailsPackageWithFlightApi.prepareCalcPerFlightCombo(flightDepartureId, $(e.currentTarget).val());
        });

        $(document).on('click', '[data-flightdepartureid]', e => {
            const $target = $(e.currentTarget);
            const flightDepartureId = $target.attr('data-flightdepartureid');

            let html = '';
            detailsPackageWithFlightApi.calc.flights.departures.forEach(departure => {
                departure.offers.forEach(offer => {
                    if (offer.id === flightDepartureId) {

                        let airline = $.grep(detailsPackageWithFlightApi.calc.flights.airlines, function( airline ) {
                            return airline.code === offer.airlineCode;
                        })[0];

                        html += `<div class="d-flex align-items-end">
                            <img src="${ airline.thumbnailFull }">
                            <div class="ms-3 ms-lg-4">
                                <div class="lead fw-bold">${ airline.name }</div>
                                <div class="bg-secondary text-white small px-2 rounded fw-bold">${ offer.class }</div>
                            </div>
                        </div>`;

                        // first departure and last arrival
                        offer.segments.forEach((segment, index) => {
                            html += detailsPackageWithFlightApi.prepareFlightSegmentHtml(offer, segment, index);
                        });
                    }
                });
            });

            $("#flightInfo .modal-body").html(html);
        });

        $(document).on('click', '[data-flightrefid]', e => {
            const $target = $(e.currentTarget);
            const flightReturnId = $target.attr('data-flightrefid');
            const $flightDeparture = $('[name="flightDepartureId"]:checked');
            const flightDepartureId = $flightDeparture.val();

            let html = '';

            
            detailsPackageWithFlightApi.calc.flights.departures.forEach(departure => {
                departure.offers.forEach(offer => {
                    if (offer.id === flightDepartureId) {

                        let airline = $.grep(detailsPackageWithFlightApi.calc.flights.airlines, function( airline ) {
                            return airline.code === offer.airlineCode;
                        })[0];
                        html += `<div class="d-flex align-items-end"><img src="${ airline.thumbnailFull }"><div class="lead fw-bold">${ airline.name }</div><div class="bg-light ms-2 px-2 rounded">${ offer.class }</div></div>`;

                        offer.returns.forEach(return_item => {
                            if (return_item.flightRefId === flightReturnId) {
                                return_item.segments.forEach((segment, index) => {
                                    html += detailsPackageWithFlightApi.prepareFlightSegmentHtml(return_item, segment, index);
                                });
                            }
                        });
                    }
                });
            });

            $("#flightInfo .modal-body").html(html);
        });
    },
    prepareAvailabilityForm() {
        $('.tickets').append('<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>');
        $.post('/services/dynamic_package_availability_form_data/', {
            objectId: this.params.referenceId,
            dynamicPackage: this.params.dynamicPackage,
            language: functions.getLang(),
            flightAvailabilityStatus: true,
            placeFromId: this.params.placeFromId,
        }).always(response => {
            response = response ? JSON.parse(response) : null;

            if (response.status) {
                const prepared = this.getPackageDepartures(response.data.items, response.data.flights);
                this.departurePoints = response.data.departurePoints;
                const serviceCodes = response.data.serviceCodes;
                //const $nights = $("[name='nights']");

                this.enable = prepared.enable;
                this.flights = prepared.flights;
                this.prices = prepared.prices;

                const $service = $("[name='serviceCode']");
                const $serviceWrapper = $service.parents('.service-code-wrapper');
                if (serviceCodes.length) {
                    $serviceWrapper.removeClass('d-none')
                    serviceCodes.forEach((serviceCode, key) => {
                        this.allowedServices.forEach((allowedService) => {
                            if (allowedService.key === serviceCode) {
                                serviceCodes[key] = {id: allowedService.key};
                                serviceCodes[key].text = allowedService.text;

                            }
                        });
                    });

                    $service.select2({
                        data: serviceCodes,
                        minimumResultsForSearch: -1
                    });
                } else {
                    $serviceWrapper.addClass('d-none');
                }

                let nights = this.enable.map(i => i['nights']);
                nights = nights.filter((value, index, array) => array.indexOf(value) === index).sort((a, b) => {
                    return a - b
                });

                if (nights.length) {
                    $('.package-duration-wrapper').removeClass('d-none');
                    $('.package-duration').text(nights.join(', ') + ' noćenja');

                    let _nights = [];
                    nights.forEach((night, key) => {
                        _nights.push({id: night, text: night})

                        if (!this.params.nights) {
                            this.params.nights = night;
                        }
                    });

                    /*$nights.select2({
                        data: _nights,
                        minimumResultsForSearch: -1
                    });*/

                    //setTimeout(() => $nights.val(this.params.nights).trigger('change'));

                } else {
                    $('.package-duration-wrapper').addClass('d-none');
                }

                const $detailsDatepicker = $("#details-datepicker");
                $detailsDatepicker.attr('data-departures', JSON.stringify(this.enable));
                $detailsDatepicker.attr('data-flights', JSON.stringify(this.flights));
                $detailsDatepicker.attr('data-prices', JSON.stringify(this.prices));
                $detailsDatepicker.attr('data-departurePoints', JSON.stringify(this.departurePoints));

                $detailsDatepicker.find('[data-input]').each((i, elem) => {
                    elem._departurePicker = new DeparturePicker(elem);
                });

                this.setDefaultDeparture();
                functions.setFormData(this.form, this.params);

                // showFlightTickets must MANDATORY be after setFormData
                this.params.dateFrom && this.showTransportTicket();
                //this.params.dynamicPackage == 2 && this.setDeparturePoints();
                this.setDeparturePoints();

                this.getCalculation();

                this.$form.on('change', e => {
                    e.preventDefault();
                    const $target = $(e.currentTarget);
                    const data = functions.getFormData($target);

                    this.params.dateFrom = data.dateFrom;
                    this.params.dateTo = data.dateTo;
                    this.params.guests = data.guests;
                    this.params.time = data.time;
                    this.params.duration = data.duration;
                    this.params.transportUnitId = data.transportUnitId;
                    this.params.placeFromId = data.placeFromId;

                    functions.setUrlData(
                        {
                            'dateFrom': this.params.dateFrom,
                            'dateTo': this.params.dateTo,
                            'aDateFrom': this.params.aDateFrom,
                            'aDateTo': this.params.aDateTo,
                            'guests': this.params.guests,
                            'time': this.params.time,
                            'duration': this.params.duration,
                            'transportUnitId': this.params.transportUnitId,
                            'placeFromId': this.params.placeFromId,
                        },
                        true,
                        true);
                });

                $(document).on('click', '.ticket', e => {
                    this.setTransportTicket($(e.currentTarget), true);
                });

                let travelProgramIds = [];
                response.data.flights.forEach((flight) => {
                    if (flight.travelProgramId ) {
                        travelProgramIds.push(flight.travelProgramId);
                    }
                });

                this.getTravelProgram(travelProgramIds);

            }
        });
    },
    getTravelProgram(travelProgramIds) {
        let programURL = $('[data-programurl]').length ? $('[data-programurl]').attr('data-programurl') : null;

        if(programURL && travelProgramIds.length) {
            programURL += '?publicIds=' + travelProgramIds.join(',') + '&language=' + functions.getLang();
            $.get(programURL).done(response => {
                response = JSON.parse(response);
                if (response.status) {
                    this.travelProgram = response.html;
                    this.showTravelProgram();
                } else {
                    $('.travel-program-link').addClass('d-none');
                }
            }).fail(e => {
                $('.travel-program-link').addClass('d-none');
            });
        }
    },
    showTravelProgram() {
        const $ticket = $('.ticket.active');
        const travelProgramId = JSON.parse($ticket.attr('data-travelprogramid'));
        const $modal = $('#travelProgramModal');

        let $travelProgram = $(this.travelProgram).find('#travelProgram' + travelProgramId);
        let html = $travelProgram.html();
        $modal.find('.modal-body').html(html);
        $modal.find('.btn-print').attr('data-params', $travelProgram.attr('data-print'));

        $('.travel-program-link').removeClass('d-none');
    },
    getPackageDepartures(rates, flightTitles) {
        let departures = {};

        Object.keys(rates).forEach(index => {
            let rate = rates[index];
            let flight = rate.flight;
            // let unique = rate.dateFrom + ',' + rate.dateTo + ',' + flight.timeDepartureFrom + ',' + flight.timeReturnFrom;
            //let unique = rate.aDateFrom + ',' + rate.aDateTo + ',' + rate.dateFrom + ',' + rate.dateTo;
            let unique = rate.dateFrom + ',' + rate.dateTo;
            
            let aDateFrom = rate.aDateFrom;
            let aDateTo = rate.aDateTo;

            let flightUnitId = flight.unitId;

            if ( flight.timeDepartureFrom ) {
                flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
            }

            let flightUnique = flightUnitId + (flight.time ? '_' + flight.time : '');

            if ( ! departures[unique]) {
                let flights = {};
                flights[flightUnique] = flight;

                let rates = {};
                rates[rate.id] = rate;

                departures[unique] = {
                    'dateFrom'      : rate.dateFrom,
                    'dateTo'        : rate.dateTo,
                    'aDateFrom'     : aDateFrom,
                    'aDateTo'       : aDateTo,
                    'time'          : flight.time || '',
                    'duration'      : rate.accommodationDuration,
                    'nights'        : rate.accommodationDuration,
                    'flightUnitId'  : flightUnitId,
                    'flights'       : flights,
                    'rates'         : rates,
                };
            } else {
                let departure = departures[unique];
                departure.flights[flightUnique] = flight;
                departure.rates[rate.id] = rate;
            }
        });

        this.departures = departures;

        let enable = [];
        let prices = {};
        let flights = [];

        Object.keys(departures).forEach(index => {
            let rate = departures[index];

            enable.push({
                dateFrom: rate['dateFrom'],
                dateTo: rate['dateTo'],
                aDateFrom: rate['aDateFrom'],
                aDateTo: rate['aDateTo'],
                duration: rate['duration'],
                nights: rate['duration'],
                time: rate['time'],
                flightUnitId: rate['flightUnitId'],
            });

            let arrival = rate.dateFrom;
            let departure = rate.dateTo;

            let departureDay = detailsPackageWithFlightApi.getWeekDay(arrival);
            let returnArrivalDay = detailsPackageWithFlightApi.getWeekDay(departure);

            Object.keys(rate.flights).forEach(function(index) {

                let flight = rate.flights[index];

                if ( flight.timeDepartureFrom ) {
                    flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
                }

                let timeDepartureFrom = flight['timeDepartureFrom'];
                let timeDepartureTo = flight['timeDepartureTo'];
                let timeReturnFrom = flight['timeReturnFrom'];
                let timeReturnTo = flight['timeReturnTo'];
                let placeFromId = flight['placeFromId'];
                let placeFromName = flight['placeFrom'];
                let placeToName = flight['placeTo'];
                let departureDuration = flight['departureDuration'];
                let returnDuration = flight['returnDuration'];
                let arrivalDate = flight['arrivalDate'];
                let returnDate = flight['returnDate'];
                let availabilityStatus = flight['availabilityStatus'];

                let flightTitle;
                let flightSmallImg;
                let travelProgramId;
                flightTitles.forEach((ft) => {
                    if (ft.id == flight.objectId) {
                        flightTitle = ft.title ? ft.title : ft.supplierTitle;
                        flightSmallImg = ft.images.small ? ft.images.small : '';
                        travelProgramId = ft.travelProgramId;
                    }
                });

                let arrivalDay = detailsPackageWithFlightApi.getWeekDay(arrivalDate);
                let returnDepartureDay = detailsPackageWithFlightApi.getWeekDay(returnDate);
                
                flights.push({
                    duration              : rate.duration,
                    dateFrom              : rate.dateFrom,
                    dateTo                : rate.dateTo,    
                    aDateFrom             : rate.aDateFrom,
                    aDateTo               : rate.aDateTo,
                    flightId              : flight.objectId,
                    flightTitle           : flightTitle,
                    flightSmallImg        : flightSmallImg,
                    travelProgramId       : travelProgramId,
                    flightUnitId          : flight.unitId,
                    departureDay          : departureDay,
                    returnDepartureDay    : returnDepartureDay,
                    arrivalDay            : arrivalDay,
                    returnArrivalDay      : returnArrivalDay,
                    timeDepartureFrom     : timeDepartureFrom,
                    timeDepartureTo       : timeDepartureTo,
                    timeReturnFrom        : timeReturnFrom,
                    timeReturnTo          : timeReturnTo,
                    time                  : flight.time,
                    placeFromId           : placeFromId,
                    placeFromName         : placeFromName,
                    placeToName           : placeToName,
                    departureDuration     : departureDuration,
                    returnDuration        : returnDuration,
                    arrivalDate           : arrivalDate,
                    returnDate            : returnDate,
                    availabilityStatus    : availabilityStatus,
                });
            });

        });

        return {
            enable : enable,
            prices : prices,
            flights : flights
        };

    },
    getWeekDay(date) {

        const d = new Date(date);
        const days = [
            "nedelja",
            "ponedeljak",
            "utorak",
            "sreda",
            "četvrtak",
            "petak",
            "subota"
        ];

        let day = d.getDay()

        return days[day];
    },
    getDeparturePoints (params) {
        return $.post('/services/departure_points/', { dynamicPackage: params.dynamicPackage, objectId: params.objectId });
    },
    setDeparturePoints () {
        const $placeFromId = $('[name="placeFromId"]');
        $placeFromId.empty();

        this.departurePoints && this.departurePoints.forEach(departurePoints => {
            const newOption = new Option(departurePoints.placeName, departurePoints.placeId, false, this.params.placeFromId == departurePoints.placeId);
            $placeFromId.append(newOption);
        });

        /*this.getDeparturePoints({
            dynamicPackage: this.params.dynamicPackage,
            objectId: this.params.referenceId
        }).then(response => {
            departurePoints = response;
            
            departurePoints.forEach(departurePoints => {
                const newOption = new Option(departurePoints.name, departurePoints.id, false, this.params.placeFromId == departurePoints.id);
                $placeFromId.append(newOption);
            });
        });*/

        //$placeFromId.val(this.params.placeFromId).trigger('change');
    },
    showPlacesFrom (tickets) {
        $('.tickets').addClass('show-active');
        //const $transportUnitId = $('[name="transportUnitId"]');
        //$transportUnitId.empty();

        /*tickets.forEach(ticket => {
            const newOption = new Option(ticket.placeFromName, ticket.flightUnitId, false, false);
            $transportUnitId.append(newOption);
        });*/

        //$transportUnitId.val(this.params.transportUnitId);
    },
    showTransportTicket(){
        const dataTransport = JSON.parse($('[data-flights]').attr('data-flights'));

        let dateFrom = this.params.dateFrom;
        let dateTo = this.params.dateTo;

        let duration = this.params.duration;
        let time = this.params.time != ' ' && (this.params.time && ! this.params.time.startsWith('null')) ? this.params.time : null;
        time = time == 'undefined' ? null : time;

        if (duration) {
            if (! $('.duration-item[data-datefrom="' + dateFrom + '"][data-dateto="' + dateTo + '"][data-duration="' + duration + '"]').length) {
                duration = this.params.duration = null;
            }
        }

        if (! duration && $('.duration-item.active').length) {
            duration && $('.duration-item.active').attr('data-duration');
        }

        let tickets = dataTransport.filter(ticket => {
            return ticket.dateFrom == dateFrom 
                && ticket.dateTo == dateTo 
                && (duration ? ticket.duration == duration : true)
                //&& (time && ticket.time ? ticket.time == time : true);
        });

        tickets.sort((a, b) => {
            return a.duration - b.duration;
        });

        //this.params.dynamicPackage == 2 && this.showPlacesFrom(tickets);
        this.showPlacesFrom(tickets);
        
        this.renderTransportTickets(tickets);
    },
    renderTransportTickets(tickets) {
        const $tickets = $('.tickets').empty();

        const isFlight = this.params.dynamicPackage == 1;

        let hasActiveTicket = tickets.find((ticket) => {
            return ticket.flightUnitId == this.params.transportUnitId;
        });

        $tickets.append(
            `<div class="tickets-details-default mb-3">
                <h3 class="text-center">Izaberite letove</h3>
                <p class="text-center">Kombinujte polazak, povratak i tarife po svojoj meri.</p>
    
                <div class="tickets-default"></div>
            </div>`
        );

        tickets.forEach((ticket, index) => {
            const time = ticket.timeDepartureFrom && ticket.timeReturnFrom ? ticket.timeDepartureFrom + ',' + ticket.timeReturnFrom : null;
            this.params.time = ! this.params.time && index == 0 ? time : this.params.time;

            if (ticket.flightTitle == 'Arena Travel d.o.o.') {
                ticket.flightTitle = null;
            }

            if ( ! hasActiveTicket && index == 0) {
                this.params.transportUnitId = ticket.flightUnitId;
            }

            if (! ticket.flightSmallImg) {
                ticket.flightSmallImg = isFlight 
                ? '/wp-content/uploads/avio-aranzmani.jpg'
                : '/wp-content/uploads/bus-aranzmani.jpg';
            }

            // ticket.departureDay
            // ticket.arrivalDay
            // ticket.returnArrivalDay
            // ticket.returnDepartureDay

            $tickets.find('.tickets-default').append(`
                <div class="ticket ${ isFlight ? 'ticket-flight ticket-flight-api' : 'ticket-bus'}"
                    data-aDateFrom="${ ticket.aDateFrom }"
                    data-aDateTo="${ ticket.aDateTo }"
                    data-transportUnitId="${ ticket.flightUnitId }"
                    data-time="${ ticket.time }"
                    data-placeFromId="${ ticket.placeFromId }"
                    data-travelProgramId="${ ticket.travelProgramId }">

                    <div class="row g-0">
                        ${ ticket.flightSmallImg ? `
                            <div class="col-lg-1">
                                <div class="ticket-img">
                                    ${ ticket.flightTitle ? `<div class="ticket-label">${ ticket.flightTitle }</div>` : '' }
                                    <img class="ozad" src=${ ticket.flightSmallImg }>
                                </div>
                            </div>
                        ` : '' }
                        <div class="col-lg">
                            <div class="ticket-departure">
                                <div class="row flex-nowrap">
                                    <div class="col-auto col-xl-auto text-start">
                                        <div class="fw-bold">${ ticket.timeDepartureFrom ? ' ' + ticket.timeDepartureFrom : '' }</div>
                                        <div class="">${ functions.formatDate(ticket.dateFrom) }</div>
                                        <div class="ticket-placeFrom d-none d-lg-block"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeFromName }">
                                            <small>${ ticket.placeFromName }</small>
                                        </div>
                                    </div>
                                    <div class="col mt-3 mt-lg-0">
                                        <div class="text-center small text-uppercase d-none d-lg-block"><small>Polazak</small></div>
                                        <div class="header-flight-time-separator"></div>
                                        <div class="d-none d-lg-flex flex-column align-items-center text-center${ ticket.departureDuration ? '  mt-2 mb-3 mb-lg-0' : '' }">
                                            ${ ticket.departureDuration ? `<span class="badge bg-warning small"><small>${ ticket.departureDuration } h</small></span>` : '' }
                                        </div>
                                    </div>
                                    <div class="col-auto col-xl-auto text-start">
                                        <div class="fw-bold">${ ticket.timeDepartureTo ? ' ' + ticket.timeDepartureTo : '' }</div>
                                        <div class="">${ functions.formatDate(ticket.arrivalDate) }</div>
                                        <div class="ticket-placeTo d-none d-lg-block"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeToName }">
                                            <small>${ ticket.placeToName }</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="row d-lg-none gx-3 text-start mt-3">
                                    <div class="col-auto">
                                        <i class="fa-solid fa-plane"></i>
                                    </div>
                                    <div class="col">
                                        <div class="ticket-placeFrom"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeFromName }">
                                            <small>${ ticket.placeFromName }</small>
                                        </div>
                                        
                                        <div class="ticket-placeTo"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeToName }">
                                            <small>${ ticket.placeToName }</small>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        ${ ticket.departureDuration ? `<span class="badge bg-warning small"><small>${ ticket.departureDuration } h</small></span>` : '' }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg">
                            <div class="ticket-return">
                                <div class="row flex-nowrap">
                                    <div class="col-auto col-xl-auto text-start">
                                        <div class="fw-bold">${ ticket.timeReturnFrom ? ' ' + ticket.timeReturnFrom : '' }</div>
                                        <div class="">${ functions.formatDate(ticket.returnDate) }</div>
                                        <div class="ticket-placeTo d-none d-lg-block"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeToName }">
                                            <small>${ ticket.placeToName }</small>
                                        </div>
                                    </div>
                                    <div class="col mt-3 mt-lg-0">
                                        <div class="text-center small text-uppercase d-none d-lg-block"><small>Povratak</small></div>
                                        <div class="header-flight-time-separator"></div>
                                        <div class="d-none d-lg-flex flex-column align-items-center text-center${ ticket.returnDuration ? ' mt-2 mb-3 mb-lg-0' : '' }">
                                            ${ ticket.returnDuration ? `<span class="badge bg-warning small"><small>${ ticket.returnDuration } h</small></span>` : '' }
                                        </div>
                                    </div>
                                    <div class="col-auto col-xl-auto text-start">
                                        <div class="fw-bold">${ ticket.timeReturnTo ? ' ' + ticket.timeReturnTo : '' }</div>
                                        <div class="">${ functions.formatDate(ticket.dateTo) }</div>
                                        <div class="ticket-placeFrom d-none d-lg-block"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeFromName }">
                                            <small>${ ticket.placeFromName }</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="row d-lg-none gx-3 text-start mt-3">
                                    <div class="col-auto">
                                        <i class="fa-solid fa-plane"></i>
                                    </div>
                                    <div class="col">
                                        <div class="ticket-placeTo"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeToName }">
                                            <small>${ ticket.placeToName }</small>
                                        </div>
                                        
                                        <div class="ticket-placeFrom"
                                            data-bs-toggle="tooltip" 
                                            data-bs-placement="top" 
                                            title="${ ticket.placeFromName }">
                                            <small>${ ticket.placeFromName }</small>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        ${ ticket.departureDuration ? `<span class="badge bg-warning small"><small>${ ticket.departureDuration } h</small></span>` : '' }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ticket-tail">
                        <div class="ticket-tail-check">
                            <i class="fa-light fa-check"></i>
                            <div class="label-selected"
                                data-labelSelected="Odabrano"
                                data-labelSelect="Odaberi">
                                Odaberi
                            </div>
                        </div>
                    </div>
                    
                </div>    
            `);

            //this.params.aDateFrom = $('.ticket.active').attr('data-adatefrom');
            //this.params.aDateTo = $('.ticket.active').attr('data-adateto');
        });

        let $ticket = $('.ticket[data-transportUnitId="' +  this.params.transportUnitId + '"]').first();

        if (this.params.placeFromId) {
            const $placeTicket = $('.ticket[data-placefromid="' +  this.params.placeFromId + '"]');
            if ($placeTicket.length) $ticket = $placeTicket;
        }

        //const $ticket = $('.ticket[data-transportUnitId="' +  this.params.transportUnitId + '"]');//.first();
        $ticket.length && this.setTransportTicket($ticket);
    },
    setTransportTicket($ticket, triggerChange = false) {
        $('.ticket').removeClass('active');

        const $prevLabelSelected = $('.ticket').find('.label-selected');
        $prevLabelSelected.text($prevLabelSelected.attr('data-labelSelect'));

        $ticket.addClass('active');
        const $labelSelected = $ticket.find('.label-selected');
        $labelSelected.text($labelSelected.attr('data-labelSelected'));

        this.getParams();
        let time = $ticket.attr('data-time');
        let aDateFrom = $ticket.attr('data-adatefrom');
        let aDateTo = $ticket.attr('data-adateto');
        let unitId = $ticket.attr('data-transportunitid');

        const $placeFromId = $('[name="placeFromId"]');

        setTimeout(() => {
            if ($ticket.hasClass('active') && $placeFromId.length && $placeFromId.val()) {
                const placeFrom = $placeFromId.parents('.form-floating').find('.select2-selection__rendered').text();
                $ticket.find('.ticket-placeFrom').text(placeFrom);
            }
        });

        //$('[name="time"]').val(time);
        //$('[name="aDateFrom"]').val(aDateFrom);
        //$('[name="aDateTo"]').val(aDateTo);

        this.params.time = time;
        this.params.aDateFrom = aDateFrom;
        this.params.aDateTo = aDateTo;
        this.params.transportUnitId = unitId;

        triggerChange && this.$form.change();
    },
    setDefaultDeparture() {
        this.params.dateFrom = ! this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateFrom : this.params.dateFrom;
        this.params.dateTo = ! this.params.dateTo && this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateTo : this.params.dateTo;

        let departure = this.departures ? this.departures[this.params.dateFrom + ',' + this.params.dateTo] : null;
        ! this.params.time && departure && (this.params.time = departure.time);
        
        departure = departure || this.departures[this.params.dateFrom + ',' + this.params.dateTo + ',' + this.params.time]
        this.params.aDateFrom = departure && departure.aDateFrom ? departure.aDateFrom : null;
        this.params.aDateTo = departure && departure.aDateTo ? departure.aDateTo : null;
        this.params.transportUnitId = departure && departure.flightUnitId ? departure.flightUnitId : null;
        
        //this.params.dateFrom = ! this.params.dateFrom && departures.length ? departures[0].dateFrom : this.params.dateFrom;
        //this.params.dateTo = ! this.params.dateTo && this.params.dateFrom && departures.length ? departures[0].dateTo : this.params.dateTo;
    },
    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates === '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getCalculation(params) {
        const cParams = params ? params : this.params;
        cParams.calcPerService = 1;
        const calculation = details.getCalculation(cParams);

        $(".units-no-result-msg").addClass('d-none');
        $(".unit").addClass('d-none');
        $(".tickets-details").addClass('d-none');

        if(calculation) {

            $('.units-spinner').removeClass('d-none');

            //$('.rate-container').addClass('d-none');

            calculation
                .done(response => {
                    this.calculationDone(response, cParams);
                    $('.units-spinner').addClass('d-none');
                }).fail(error => {
                    console.log(error);
                });

            return;

        } else {
            if (+this.params.isTravelgate) {
                $(".unit-default").removeClass('d-none');
            }

            $('.tickets').removeClass('d-none');
        }

        $('.rate-container').removeClass('d-none');
        $('.block-totals-per-service').addClass('d-none');
        $('.unit-error-message').addClass('d-none');
    },
    preparePriceAndBooking(unitId, $unit, unitData) {

        const $totalPerServiceBlock = $unit.find('.totals-per-service');
        const totalPerServiceHtml = $totalPerServiceBlock.html();

        $totalPerServiceBlock.html('');

        const unitServices = Object.keys(unitData.services);
        const unitServiceCount = unitServices.length;

        unitServices.forEach(( serviceId) => {

            const dataPerService = unitData.services[serviceId];
            
            const unitCalc = dataPerService.calc;
            const currencySymbol = unitCalc.currencySymbol;
            const bookingStatus = dataPerService.booking.status;
            const unitCalcItems = unitCalc.items;
            const total = +unitCalc.total.toFixed(2);
            const pricelistid = unitCalc.items[0].pricelistId;

            const $totalPerServiceHtml = $(totalPerServiceHtml);

            let priceOld = details.getCalcTotalOld(unitCalcItems);
            priceOld = +priceOld.toFixed(2);

            let serviceText = '';
            if (dataPerService.customServiceName) {
                serviceText = dataPerService.customServiceName;
            } else {
                detailsPackageWithFlightApi.allowedServices.forEach((allowedService) => {
                    if (dataPerService.serviceId && +allowedService.id === +dataPerService.serviceId ||
                        dataPerService.serviceCode && allowedService.key === dataPerService.serviceCode){
                        serviceText = allowedService.text;
                    }
                });

                if ( ! serviceText)
                {
                    if (dataPerService.serviceName) {
                        serviceText = dataPerService.serviceName;
                    }
                }
            }

            let totalRounded = functions.formatMoney(total, 0, '', '');
            $totalPerServiceHtml.attr('style', 'order:' + totalRounded);
            $totalPerServiceHtml.addClass('order-' + totalRounded);
            $totalPerServiceHtml.attr('data-order' , totalRounded);

            const $radio = $totalPerServiceHtml.find('[type="radio"]');

            const radioVal = dataPerService.serviceId || dataPerService.serviceCode;
            $radio.val(radioVal);
            $radio.attr('name', 'service-' + unitId);
            $radio.attr('id', 'service-' + unitId + '-' + radioVal);
            $radio.attr('data-servicekey', dataPerService.serviceCode ? 'serviceCode' : 'serviceId');

            let extra = {};
            if (dataPerService.optionRefId) {
                extra.optionRefId = dataPerService.optionRefId;
            }

            if (unitData.unitName) {
                extra.unitName = unitData.unitName;
            }

            if (unitData.remoteUnitId) {
                extra.remoteUnitId = unitData.remoteUnitId;
            }

            if (dataPerService.cancellationPolicy) {
                extra.cancellationPolicy = dataPerService.cancellationPolicy;
            }

            $radio.attr('data-extra', JSON.stringify(extra));

            const $label = unitServiceCount > 1 ? $totalPerServiceHtml.find('label') : $unit.find('.service-label');
            $label.text(serviceText);
            $label.attr('for', 'service-' + unitId + '-' + radioVal);

            const $oldTotal = unitServiceCount > 1 ? $totalPerServiceHtml.find('[data-oldtotalperservice]') : $unit.find('.price-old');
            $oldTotal.text(priceOld.toFixed(0) > total.toFixed(0) ? currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',') : '');
            $oldTotal.attr('data-oldtotalperservice', priceOld.toFixed(0) > total.toFixed(0) ? priceOld : '');

            const $total = unitServiceCount > 1 ? $totalPerServiceHtml.find('[data-totalperservice]') : $unit.find('.price');
            $total.text(currencySymbol + ' ' + functions.formatMoney(total, 0, '.', ','));
            $total.attr('data-totalperservice', total);
            $total.attr('data-currency', currencySymbol);
            $total.attr('data-bookingStatus', bookingStatus);
            $total.attr('data-pricelistid', pricelistid);

            $totalPerServiceBlock.append($totalPerServiceHtml[0].outerHTML);
        });

        let minp = null;
        $totalPerServiceBlock.find("[data-order]").each((index, elem) => {
            let p = +$(elem).attr('data-order');
            if (minp === null || p < minp) {
                minp = p;
            }
        });

        $totalPerServiceBlock.find(".order-" + minp).find('[type="radio"]').click();
        $totalPerServiceBlock.find(".order-" + minp).addClass('border-0');
    },
    calculationDone(response, params) {
        if(response.status) {
            if (response.flights) {
                $('.tickets').addClass('d-none');
                detailsPackageWithFlightApi.calc = {
                    accommodation: response.data,
                    aDateFrom: response.aDateFrom,
                    aDateTo: response.aDateTo,
                    accommodationPeriods: response.accommodation || [],
                    flights: response.flights
                };
    
                detailsPackageWithFlightApi.renderFlightOptions();
            } else {
                $('.tickets').removeClass('d-none');
                detailsPackageWithFlightApi.showRooms(response.data);
            }
        }
    },
    showRooms(data) {

        $(".units-no-result-msg").addClass('d-none');

        Object.entries(data).forEach(unit => {
            const unitId = unit[0];
            const unitData = unit[1];
            let $unit = $('.unit[data-unitid=' + unitId + ']');
            let $unitModal = $("#unitModal-" + unitId);
            if ( ! $unit.length )
            {
                if (unitId.indexOf('_') === -1) return;

                const _unitId = unitId.replace(/_\d+$/, "");
                const $_unitId = $($('.unit[data-unitid=' + _unitId + ']').prop('outerHTML'));

                $_unitId.attr('data-dynamicunitid', unitId);
                $(".units").append($_unitId);

                $unit = $('.unit[data-dynamicunitid=' + unitId + ']');
                $unitModal = $("#unitModal-" + _unitId);
            }

            let isBookable = false;

            const unitServiceCount = unitData.services ? Object.values(unitData.services).length : 0;
            $unit.find('.rate-container').length && $unit.find('.rate-container').toggleClass('d-none', unitServiceCount > 1);

            if(unitData.services && details.isBookablePerService(unitData.services)) {
                isBookable = true;
                const total = details.getMinPricePerService(unitData.services);
                detailsPackageWithFlightApi.preparePriceAndBooking(unitId, $unit, unitData);
                $unit.prop('style', 'order: ' + parseInt(total));

                $unit.find('.price-from-label').addClass('d-none');
                $unit.find('.total-label').removeClass('d-none');
                $unit.find('.price-wrapper').removeClass('d-none');
                $unit.find('.service-label').removeClass('d-none');
            } else {
                $unit.prop('style', 'order: 100000;');
                $unit.find('.total-label').addClass('d-none');
                $unit.find('.price-wrapper').addClass('d-none');
                $unit.find('.service-label').addClass('d-none');
            }

            let error = ! isBookable ? details.getCalcErrorMessage(this.params.calcErrorMessages, unitData) : null;

            $unit.find('.unit-error-message').toggleClass('d-none', isBookable);
            $unit.find('.unit-error-message').text(error);

            $unit.find('.price-from-label').addClass('d-none');
            //$unit.find('.total-label').removeClass('d-none');

            $unit.find('.block-totals-per-service').toggleClass('d-none', ! isBookable || unitServiceCount < 2);
            $unit.find('.fast-and-secure-label').toggleClass('d-none', ! isBookable);
            $unit.find('.add-to-cart').toggleClass('d-none', ! isBookable);
            $unit.find('.btn-book-one-unit').toggleClass('d-none', ! isBookable);
            $unit.find('.btn-request').toggleClass('d-none', isBookable);
            $unit.toggleClass('d-none', ! isBookable);

            if (this.params.isTravelgate) {

                $unit.find('[data-unitName]').text(unitData.unitName);
                $unitModal.find('.modal-unit-name').html(unitData.unitName);
                let totalGuests = +detailsPackageWithFlightApi.params.guests.split(',')[0] + +detailsPackageWithFlightApi.params.guests.split(',')[1];
                $unit.find('.unit-no-guests').text(totalGuests);
            }

        });

        if ( ! $(".units .unit").not('.d-none').length) {
            $(".units-no-result-msg").removeClass('d-none');
        }
    },
    prepareFlightSegmentHtml(offer, segment, index) {

        let baggageDetails = offer.baggage;
        let baggage = $.grep(baggageDetails, function( baggage ) {
            return baggage.segmentId === segment.id;
        })[0];

        if ( ! baggage) return '';

        let baggagehtml = '';
        if (baggage.baggageType == 1) {
            if (baggage.unitType == 2) {
                if (baggage.piece > 0) {
                    baggagehtml += 'uključen u cenu';
                } else {
                    baggagehtml += 'nije uključen u cenu.';
                }
            }
        }

        return `
            <div class="my-4">
                <div class="mb-3 d-flex align-items-center">
                    <div class="transfer-num me-2">${ index+1 }</div>
                    <div class="fw-bold">Let ${ index+1 }</div>
                </div>

                <div class="row mb-3">
                    <div class="col-auto text-end">
                        <div class="fw-bold">${ segment.departure.time }</div>
                        <div>${ functions.formatDate(segment.departure.date) }</div>
                    </div>
                    <div class="col-auto">
                        <div class="bg-secondary rounded-circle" style="height: 8px; width: 8px;"></div>
                        <div class="bg-muted mx-1" style="height: 90%; width: 1px;"></div>
                    </div>
                    <div class="col">
                        <div>${ segment.departure.airport }</div>
                        <div class="text-muted">Polazak</div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-auto text-end">
                        <div class="fw-bold">${ segment.arrival.time }</div>
                        <div>${ functions.formatDate(segment.arrival.date) }</div>
                    </div>
                    <div class="col-auto">
                        <div class="bg-secondary rounded-circle" style="height: 8px; width: 8px;"></div>
                        <div class="bg-muted mx-1" style="height: 90%; width: 1px;"></div>
                    </div>
                    <div class="col">
                        <div>${ segment.arrival.airport }</div>
                        <div class="text-muted">Dolazak</div>
                    </div>
                </div>

                <div class="box-baggage mt-3"><i class="fa-solid fa-suitcase me-2"></i>Prtljag ${ baggagehtml }</div>
            </div>
        `;

        return `
            <div class="border rounded p-2">
                <div class="transfer-num">${ index+1 }</div>
                Polazak: ${ segment.departure.airport + ' ' + functions.formatDate(segment.departure.date)  + ' ' + segment.departure.time }<br>
                Dolazak: ${ segment.arrival.airport + ' ' + functions.formatDate(segment.arrival.date) + ' ' +  segment.arrival.time }<br>
                Prtljag: ${ baggagehtml }
            </div>
        `;

    },
    prepareFlightOptionHtml(flightData, inputName, inputVal, total, offers, modal) {

        let airline = $.grep(detailsPackageWithFlightApi.calc.flights.airlines, function( airline ) {
            return airline.code === flightData.airlineCode;
        })[0];

        let $offer = '';
        offers.forEach(offer => {
            if (inputVal !== offer.id) {

                const diffBetweenOptions = detailsPackageWithFlightApi.calculateDiffBetweenOptions(offer.total, inputName === 'flightDepartureId' ? 'departure' : 'return');
                
                $offer += `<div class="py-2 d-flex justify-content-between border-bottom">
                        <div>
                            <input class="form-check-input alternative-offer pointer me-1 me-lg-2" type="radio" name="${ inputName }${ modal ? '-' + modal : '' }" id="${ offer.id }${ modal ? '-' + modal : '' }" value="${ offer.id }" data-quantity="${ offer.availableSeatCount }">
                            <label for="${ offer.id }${ modal ? '-' + modal : '' }" class="pointer mb-0">
                                ${ offer.class }
                            </label>
                            <i class="fas fa-info-circle pointer" data-${ inputName }="${ offer.id }" data-bs-toggle="modal" data-bs-target="#flightInfo"></i> <span class="badge bg-warning"><span class="availableSeatCount">${ offer.availableSeatCount }</span> sjedala</span>
                        </div>
                        <div>
                            <strong class="diff-between-options text-nowrap">${ diffBetweenOptions }</strong>
                            <!--<strong class="text-primary">€${ offer.total } | ${ detailsPackageWithFlightApi.calculateDiffBetweenOptions(offer.total, inputName === 'flightDepartureId' ? 'departure' : 'return') }</strong>-->
                        </div>
                    </div>    
                `;
            }
        });

        let diffBetweenOptions = detailsPackageWithFlightApi.calculateDiffBetweenOptions(flightData.total, inputName === 'flightDepartureId' ? 'departure' : 'return');

        // flightData.segments.length > 1 ? (flightData.segments.length > 2 ? flightData.segments.length + ' transfera' : '1 transfer') : 'Direktan let'
        
        return `<div class="accordion-item">
                <div class="accordion-header">
                    <div class="p-3 d-flex justify-content-between">
                        <div class="w-100 d-flex flex-column flex-lg-row position-relative">
                            
                            <label for="${ inputVal }${ modal ? '-' + modal : '' }" class="flex-1 mb-0">
                                <div class="row">
                                    <div class="col-auto">
                                        <div class="ticket-img" style="max-width: 150px">
                                            <img style="max-width: 150px" src=${ airline.thumbnailFull }>
                                        </div>
                                    </div>
                                    <div class="col-lg">
                                        <div class="row">
                                            <div class="col-lg order-1 order-lg-0">
                                                <div class="row gx-2 gx-lg-3">
                                                    <div class="col-auto">
                                                        <div class="fw-bold">${ flightData.departureTime }</div>
                                                        <div>${ functions.formatDate(flightData.departureDate) }</div>
                                                    </div>
                                                    <div class="col">
                                                        <div class="header-flight-time-separator"></div>
                                                    </div>
                                                    <div class="col-auto">
                                                        <div class="fw-bold">${ flightData.arrivalTime }</div>
                                                        <div>${ functions.formatDate(flightData.arrivalDate) }</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-auto mt-2 mt-lg-0 order-1 order-lg-0 d-flex flex-row justify-content-between flex-lg-column">
                                                <span>
                                                    <span class="d-lg-none">${ flightData.class } <i class="fas fa-info-circle pointer" data-${ inputName }="${ inputVal }" data-bs-toggle="modal" data-bs-target="#flightInfo"></i></span>
                                                    <span class="badge bg-warning"><span class="availableSeatCount">${ flightData.availableSeatCount }</span> sjedala</span>
                                                </span>
                                                ${ diffBetweenOptions != '€0,00' ? `<div class="d-lg-none"><strong class="diff-between-options text-nowrap">${ diffBetweenOptions }</strong></div>` : '' }
                                            </div>
                                            <div class="col-12">
                                                <div class="d-flex justify-content-between flex-nowrap">
                                                    <span>
                                                        <span class="fw-bold">${ airline.name }</span> 
                                                        <span class="d-none d-lg-inline text-nowrap text-end"><br class="d-lg-none">| Klasa: ${ flightData.class } <i class="fas fa-info-circle pointer" data-${ inputName }="${ inputVal }" data-bs-toggle="modal" data-bs-target="#flightInfo"></i></span>
                                                        <span class="badge bg-secondary">${ flightData.segments.length > 1 ? (flightData.segments.length > 2 ? flightData.segments.length + ' presedanja' : '1 presedanje') : 'Direktan let' }</span>
                                                    </span>
                                                    ${ diffBetweenOptions != '€0,00' ? `<span class="d-none d-lg-inline text-nowrap text-end"><strong class="fs-5 diff-between-options text-nowrap">${ diffBetweenOptions }</strong></span>` : '' }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </label>

                            <input class="form-check-input pointer ms-2" type="radio" name="${ inputName }${ modal ? '-' + modal : '' }" id="${ inputVal }${ modal ? '-' + modal : '' }" value="${ inputVal }" data-quantity="${ flightData.availableSeatCount }">
                            
                        </div>
                        <!--<div>
                            <strong class="text-primary">€${ flightData.total } | ${ detailsPackageWithFlightApi.calculateDiffBetweenOptions(flightData.total, inputName === 'flightDepartureId' ? 'departure' : 'return') }</strong>
                            ${ total > 0 && false ? '<strong class="text-secondary"> €' + total + '</strong>' : '' }
                        </div>-->
                    </div>
                </div>                        
                ${ $offer 
                    ? `<div>
                            <div class="d-flex align-items-center px-3 py-2">
                                <button class="btn btn-offer p-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOffer-${ inputVal }" aria-expanded="false" aria-controls="collapseOffer">
                                    <span class="fw-bold">Izaberite drugu klasu</span>
                                    <i class="fa-solid fa-angle-down ms-1"></i>
                                </button>
                            </div>
                            <div class="collapse" id="collapseOffer-${ inputVal }">
                                <div class="accordion-body pt-2 x-3">
                                    ${ $offer }
                                </div>
                            </div>
                        </div>` 
                    : '' }
            </div>      
        `;
    },
    calculateDiffBetweenOptions(total, type) {
        let diff = +total - +(type === 'departure' ? detailsPackageWithFlightApi.calc.flights.departures[0].offers[0].total : detailsPackageWithFlightApi.calc.flights.departures[0].offers[0].returns[0].total);
        return (diff > 0 ? '+€' : '€') + functions.formatMoney(diff, 2, ',', '');
    },
    renderFlightOptions() {

        if ( ! detailsPackageWithFlightApi.calc || ! detailsPackageWithFlightApi.calc.flights)
        {
            detailsPackageWithFlightApi.showRooms([]);
            return;
        }
        
        if ( ! $(".tickets-details").length) {

            $('body').append(`
                <div class="modal fade" data-bs-backdrop="false" id="flightSelect" tabindex="-1" aria-labelledby="flightSelect" aria-hidden="true">
                  <div class="modal-dialog modal-fullscreen">
                    <div class="modal-content">
                      <div class="modal-header border-0 px-3 px-lg-5 pt-4 pb-1">
                        <!--<h1 class="modal-title fs-5" id="flightSelectLabel">Izaberite letove</h1>-->
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body px-3 px-lg-5 py-4">
                        <div class="tickets-tabs"></div>
                      </div>
                      <div class="modal-footer px-3 px-lg-5 py-2 py-lg-3">
                        <button type="button" class="btn btn-lg btn-secondary fw-bold btn-tab-flight-return" data-bs-target="#return">Nastavi<i class="fa-solid fa-angle-right ms-2"></i></button>
                        <button type="button" class="btn btn-lg btn-secondary btn-flight-confirm d-none" data-bs-dismiss="modal">U redu</button>
                      </div>
                    </div>
                  </div>
                </div>  
            `);

            $(".tickets").after(`
                <div class="tickets-details mb-3">
                    <h3 class="text-center">Izaberite letove</h3>
                    <p class="text-center">Kombinujte polazak, povratak i tarife po svojoj meri.</p>
                    <hr />

                    <div class="row">
                        <div class="col-lg-6 flight-departure">
                            <div class="row mb-3">
                                <div class="col-auto d-flex flex-column justify-content-center">
                                    <i class="fa-solid fa-plane-departure fa-lg text-primary"></i>
                                </div>
                                <div class="col">
                                    <p class="fs-5 fw-medium text-dark mb-0">Izaberite polazak</p>
                                </div>
                            </div>
                            <div class="accordion" id="flight-departure-accordion"></div>
                            <button type="button" class="btn btn-flight-departure-count" data-bs-toggle="modal" data-bs-target="#flightSelect" data-tab="departure-tab">
                                <span>Pogledajte sve letove (<span class="flight-departure-count"></span>)</span><i class="fa-solid fa-angle-right"></i>
                            </button>
                        </div>
                        <div class="col-lg-6 flight-return">
                            <div class="row my-3 mt-lg-0 mb-lg-3">
                                <div class="col-auto d-flex flex-column justify-content-center">
                                    <i class="fa-solid fa-plane-arrival fa-lg text-primary"></i>
                                </div>
                                <div class="col">
                                    <p class="fs-5 fw-medium text-dark mb-0">Izaberite povratak</p>
                                </div>
                            </div>
                            <div class="accordion" id="flight-return-accordion"></div>
                            <button type="button" class="btn btn-flight-return-count" data-bs-toggle="modal" data-bs-target="#flightSelect" data-tab="return-tab">
                                <span>Pogledajte sve letove (<span class="flight-return-count"></span>)</span><i class="fa-solid fa-angle-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            `);

            $(".tickets-tabs").after(`
                <div class="tickets-details mb-3">
                    <h3 class="text-center">Izaberite letove</h3>
                    <p class="text-center">Kombinujte polazak, povratak i tarife po svojoj meri.</p>
                    <hr />

                    <ul class="nav nav-tabs" id="flightSelectTabs" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="departure-tab" data-bs-toggle="tab" data-bs-target="#departure" type="button" role="tab" aria-controls="departure" aria-selected="true">
                                <div class="row gx-3">
                                    <div class="col-auto d-none d-lg-flex flex-column justify-content-center">
                                        <i class="fa-solid fa-plane-departure fa-lg text-primary"></i>
                                    </div>
                                    <div class="col d-flex flex-column justify-content-center">
                                        <div class="departure-tab-label">Izaberite polazak</div>
                                        <div class="departure-tab-date">${ functions.formatDate(this.params.dateFrom) }</div>
                                    </div>
                                </div>
                            </button>
                        </li>
                        <hr class="mt-4" style="width: 50%; max-width: 200px;">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="return-tab" data-bs-toggle="tab" data-bs-target="#return" type="button" role="tab" aria-controls="return" aria-selected="false">
                                <div class="row gx-3 mb-lg-3">
                                    <div class="col-auto d-none d-lg-flex flex-column justify-content-center">
                                        <i class="fa-solid fa-plane-arrival fa-lg text-primary"></i>
                                    </div>
                                    <div class="col d-flex flex-column justify-content-center">
                                        <div class="return-tab-label">Izaberite povratak</div>
                                        <div class="return-tab-date">${ functions.formatDate(this.params.dateTo) }</div>
                                    </div>
                                </div>
                            </button>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade flight-departure show active" id="departure" role="tabpanel" aria-labelledby="departure-tab">
                            <div class="accordion accordion-modal" id="flight-departure-accordion-modal"></div>
                        </div>
                        <div class="tab-pane fade flight-return" id="return" role="tabpanel" aria-labelledby="return-tab">
                            <div class="accordion accordion-modal" id="flight-return-accordion-modal"></div>
                        </div>
                    </div>
                </div>
            `);

            $('body').append(`
                <div class="modal fade" id="flightInfo" tabindex="-1" aria-labelledby="flightInfo" aria-hidden="true">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header px-3 px-lg-5 py-4">
                        <h1 class="modal-title fs-5" id="flightInfoLabel">Informacije o letu</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body px-3 px-lg-5 py-4"></div>
                      <div class="modal-footer px-3 px-lg-5 py-4">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" ata-bs-target="#flightSelect" ata-bs-toggle="modal">Zatvori</button>
                      </div>
                    </div>
                  </div>
                </div>  
            `);

            $('body').on('click', '.btn-tab-flight-return', e => {
                $('.nav-link#return-tab').tab('show');
            });
            
            $('[data-bs-target="#flightSelect"][data-tab]').on('click', e => {
                const $target = $(e.currentTarget);
                const $tab = $('#flightSelect').find('[id="' + $target.attr('data-tab') + '"]');
                $tab.tab('show');
            });

            $('body').on('show.bs.tab', '.nav-link#return-tab', e => {
                $('.btn-tab-flight-return').addClass('d-none');
                $('.btn-flight-confirm').removeClass('d-none');
            });
            $('body').on('show.bs.tab', '.nav-link#departure-tab', e => {
                $('.btn-tab-flight-return').removeClass('d-none');
                $('.btn-flight-confirm').addClass('d-none');
            });

            $('body').on('show.bs.modal', '#flightSelect', e => {
                const $target = $(e.currentTarget);

                if( ! $('[name="flightRefId-1"]:checked').length) {
                    let checkedValue = $('[name="flightRefId"]:checked').val();
                    $('[name="flightRefId-1"][value="' + checkedValue + '"]').attr('checked', true);
                }

                $target.addClass('keep-opened');
            });

            $('body').on('click', '#flightSelect [data-bs-dismiss]', e => {
                $('#flightSelect').removeClass('keep-opened');
            });

            $('body').on('hide.bs.modal', '#flightSelect', e => {
                const $target = $(e.currentTarget);
                const $bookingBox = $('.booking-box');
                let $checkedInputs = $target.find('input:checked');
                
                $checkedInputs.each((index, checkedInput) => {
                    const $checkedInput = $(checkedInput);
                    const value = $checkedInput.attr('value');

                    //$bookingBox.find('[value="' + value + '"]').attr('checked', true).trigger('change');
                });
            });

            $('body').on('show.bs.modal', '#flightInfo', e => {
                const $target = $(e.currentTarget);
                const $relatedTarget = $(e.relatedTarget);
                const $dismissModal = $target.find('[data-bs-dismiss="modal"]');

                if ($relatedTarget.parents('#flightSelect').length) {
                    $dismissModal.attr('data-showFlightSelect', 1);
                } else {
                    $dismissModal.attr('data-showFlightSelect', 0);
                }
            });
            $('body').on('hidden.bs.modal', '#flightInfo', e => {
                const $target = $(e.currentTarget);
                const $dismissModal = $target.find('[data-bs-dismiss="modal"]');

                +$dismissModal.attr('data-showflightselect') && $('#flightSelect').modal('show');
            });

        }

        const $tickets = $(".tickets-details").removeClass('d-none');

        detailsPackageWithFlightApi.calc.flights.departures.forEach(departure => {
            let flightDetail = $.grep(detailsPackageWithFlightApi.calc.flights.details, function( flightDetail ) {
                return flightDetail.flightId === departure.flightId;
            })[0];

            departure.offers.forEach(offer => {
                $.extend(offer, flightDetail);

                offer.returns.forEach(return_item => {
                    let flightDetail = $.grep(detailsPackageWithFlightApi.calc.flights.details, function( flightDetail ) {
                        return flightDetail.flightId === return_item.flightId;
                    })[0];

                    $.extend(return_item, flightDetail);
                });
            });
        });

        $tickets.find(".flight-departure .accordion").empty();

        $('.flight-departure-count').text(detailsPackageWithFlightApi.calc.flights.departures.length);
        detailsPackageWithFlightApi.calc.flights.departures.length > 1 ? $('.btn-flight-departure-count').removeClass('d-none') : $('.btn-flight-departure-count').addClass('d-none');

        detailsPackageWithFlightApi.calc.flights.departures.forEach(departure => {
            let item = departure.offers[0];
            $tickets.find(".flight-departure .accordion:not(.accordion-modal)").append(detailsPackageWithFlightApi.prepareFlightOptionHtml(item, 'flightDepartureId', item.id, 0, departure.offers, 0));
            $tickets.find(".flight-departure .accordion.accordion-modal").append(detailsPackageWithFlightApi.prepareFlightOptionHtml(item, 'flightDepartureId', item.id, 0, departure.offers, 1));
        });

        //$("#flightSelect [name='flightDepartureId']:first").attr('checked', true).trigger('change');
        $("[name^='flightDepartureId']:first, #flightSelect [name^='flightDepartureId']:first").each((index, element) => {
            $(element).attr('checked', true).trigger('change');
        });
    },
    // return flight leaving from 00:00 to 04:00 (inclusive): the guest does not sleep the last night, check out is the day before (same rule as back: PriceSearch::accommodationDateTo)
    getAccommodationDateTo(returnDepartureDate, returnDepartureTime) {
        if (returnDepartureTime > '04:00') {
            return returnDepartureDate;
        }

        const [year, month, day] = returnDepartureDate.split('-').map(Number);
        return new Date(Date.UTC(year, month - 1, day - 1)).toISOString().slice(0, 10);
    },
    getAccommodationCalcPerPeriod(aDateFrom, aDateTo) {
        const calc = detailsPackageWithFlightApi.calc;

        // no period info from the back (default period only)
        if ( ! calc.aDateFrom || (calc.aDateFrom === aDateFrom && calc.aDateTo === aDateTo)) {
            return calc.accommodation;
        }

        const period = calc.accommodationPeriods.find(period => period.aDateFrom === aDateFrom && period.aDateTo === aDateTo);

        return period ? period.data : null;
    },
    prepareCalcPerFlightCombo(flightDepartureId, flightRefId) {

        detailsPackageWithFlightApi.calc.flights.departures.forEach(departure => {
            departure.offers.forEach(offer => {
                if (offer.id === flightDepartureId) {
                    offer.returns.forEach(return_item => {
                        if (return_item.flightRefId === flightRefId) {

                            // check in = departure flight lands, check out = return flight leaves the destination (the day before for flights up to 04:00)
                            const aDateFrom = offer.arrivalDate;
                            const aDateTo = detailsPackageWithFlightApi.getAccommodationDateTo(return_item.departureDate, return_item.departureTime);
                            const accCalc = detailsPackageWithFlightApi.getAccommodationCalcPerPeriod(aDateFrom, aDateTo);
                            if ( ! accCalc) return;

                            let adultPrice = 0.00;
                            let childPrice = 0.00;
                            let infantPrice = 0.00;
                            return_item.totalBreakDown.forEach(priceBreakDown_item => {
                                if (+priceBreakDown_item.passengerType === 1) {
                                    adultPrice = +priceBreakDown_item.amount;
                                }
                                else if (+priceBreakDown_item.passengerType === 2) {
                                    childPrice = +priceBreakDown_item.amount;
                                }
                                else if (+priceBreakDown_item.passengerType === 3) {
                                    infantPrice = +priceBreakDown_item.amount;
                                }
                            });

                            for (const [unit_key, unit] of Object.entries(accCalc)) {
                                if(unit.services && details.isBookablePerService(unit.services)) {
                                    for (const [service_key, service] of Object.entries(unit.services)) {
                                        service.calc.total = 0.00;
                                        for (const [item_key, item] of Object.entries(service.calc.items)) {
                                            if (+item.itemDefinitionId === 54) {
                                                let ageFrom = +(item.ageFrom || 12);
                                                let ageTo = +(item.ageTo || 99);

                                                if (ageFrom >= 12) {
                                                    item.itemTotal = adultPrice * item.quantity;
                                                    service.calc.total += item.itemTotal;
                                                }
                                                else if (ageTo <= 1) {
                                                    item.itemTotal = infantPrice * item.quantity;
                                                    service.calc.total += item.itemTotal;
                                                }
                                                else if (ageTo < 12) {
                                                    item.itemTotal = childPrice * item.quantity;
                                                    service.calc.total += item.itemTotal;
                                                }
                                            } else {
                                                service.calc.total += item.itemTotal;
                                            }
                                        }
                                    }
                                }
                            }

                            /*$(".flight-total").remove();
                            $('.flight-return').append(`
                            $('.flight-return').append(`
                                <div class="card flight-total mt-3">
                                    <div class="card-body text-secondary fw-bold text-end">TOTAL: €${ +offer.total + +return_item.total }</div>
                                </div>
                            `);*/

                            console.log('flight combo calc', JSON.parse(JSON.stringify({
                                aDateFrom: aDateFrom,
                                aDateTo: aDateTo,
                                departure: offer,
                                return: return_item,
                                accommodation: accCalc
                            })));

                            detailsPackageWithFlightApi.showRooms(accCalc);
                        }
                    });
                }
            });
        });
    }
};